/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".errorInput[_ngcontent-%COMP%]{\r\n    border: 1px solid #dd2d2d;\r\n}\r\n.rutlabel[_ngcontent-%COMP%]{\r\n\r\n    padding-top: 15px\r\n}"];
export { styles as styles };
